import { StyleSheet } from "aphrodite";

export default StyleSheet.create({
  CTASignup: {
    padding: "10px 30px",
    backgroundColor: "#02a7e3",
    color: "white !important",
    borderRadius: "5px",
    fontSize: "14px",
    textDecoration: "none",
    fontWeight: "bold",

    ":hover": {
      backgroundColor: "#02a7e3",
      backgroundImage: "linear-gradient(180deg,rgba(0,0,0,.1),rgba(0,0,0,.1))",
      textDecoration: "none"
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/Buttons/styles.js